export const MailIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.35742 7.714L9.33742 12.368C10.3004 13.009 10.7814 13.33 11.3014 13.455C11.7614 13.565 12.2404 13.565 12.6994 13.455C13.2194 13.33 13.7004 13.009 14.6634 12.368L21.6434 7.714M7.15742 19.5H16.8434C18.5234 19.5 19.3634 19.5 20.0054 19.173C20.5695 18.8852 21.0281 18.4263 21.3154 17.862C21.6434 17.22 21.6434 16.38 21.6434 14.7V9.3C21.6434 7.62 21.6434 6.78 21.3164 6.138C21.0288 5.57354 20.5699 5.11462 20.0054 4.827C19.3634 4.5 18.5234 4.5 16.8434 4.5H7.15742C5.47742 4.5 4.63742 4.5 3.99542 4.827C3.43133 5.11479 2.97278 5.57369 2.68542 6.138C2.35742 6.78 2.35742 7.62 2.35742 9.3V14.7C2.35742 16.38 2.35742 17.22 2.68442 17.862C2.97204 18.4265 3.43096 18.8854 3.99542 19.173C4.63742 19.5 5.47742 19.5 7.15742 19.5Z"
        stroke="#353F57"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
